<template>
    <ve-bar  
      height='480px' 
      width='480px' 
      :colors='chartColours'
      :data='carbonChartData.carbonChartData' 
    >
    </ve-bar>
</template>

<script>
export default {
  props:{
    type: Object,
  },

  data () {
      return {
        chartColours: ['#c6c6c6'],
    }
  },

  computed:{
    carbonTable() {
      return this.type.carbon;
    },
    carbonUnit() {
      return this.type.units;
    },

    carbonChartData() {
      const data = [];
      const unit = this.carbonUnit;
      const columns = ['carbon', unit];

      for (var i = 0; i < this.carbonTable.length; ++i) {
      //   for (let key in this.carbonTable) {
        let typ = this.carbonTable[i];

        data.push({
        carbon: typ.name,
        [unit]: Number.parseFloat(typ.value.toFixed(1))
        })
      }

      return {
          carbonChartData: { columns: columns, rows: data }
      };
    }
  }
}
</script>